import BaseController from "./BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";
import Button, { Button$PressEvent } from "sap/m/Button";
import Dialog, { Dialog$AfterCloseEvent } from "sap/m/Dialog";
import DataService from "../util/DataService";
import Text from "sap/m/Text";
import ResourceBundle from "sap/base/i18n/ResourceBundle";
import FilterOperator from "sap/ui/model/FilterOperator";
import Filter from "sap/ui/model/Filter";
import Table from "sap/m/Table";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class History extends BaseController {

    private readonly DIALOG_ID = "DialogUpdateLeave";

    public onInit(): void {
        this.getView().setModel(new JSONModel({
            editable: false,
            dialogBusy: false,
            year: new Date()
        }), "viewModel");
    }

    onAfterRendering(): void | undefined {
        this.onFilter();
    }

    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    public async onEdit(oEvent: Button$PressEvent): Promise<void> {
        DataService.getUsers();
        await this.openDialog(this.DIALOG_ID);
    }

    public async onSelect(oEvent: Button$PressEvent): Promise<void> {
        const viewModel = this.getView().getModel("viewModel") as JSONModel;

        const selectedLeave = oEvent.getSource().getSelectedItem().getBindingContext("dataModel").getObject();

        if (selectedLeave.status !== "CANCELLED") {
            viewModel.setProperty("/editable", true);
            this.getView().setModel(new JSONModel(selectedLeave), "leave");
        } else {
            viewModel.setProperty("/editable", false);
        }


    }

    public async onSaveDialog(oEvent: Dialog$AfterCloseEvent): Promise<void> {
        const viewModel = this.getView().getModel("viewModel") as JSONModel;
        const leaveData = (this.getView().getModel("leave") as JSONModel).getData();


        try {
            viewModel.setProperty("/dialogBusy", true);
            await DataService.updateLeave(leaveData);
            DataService.getUserData();
        } catch (error) {
            console.error(error);
        } finally {
            viewModel.setProperty("/dialogBusy", false);
            this.destroyDialog(this.DIALOG_ID);
        }

    }

    public async onCancelLeave(oEvent: Button$PressEvent): Promise<void> {
        const leaveData = (this.getView().getModel("leave") as JSONModel).getData();
        const resourceBundle = this.getResourceBundle() as ResourceBundle;

        const dialog = new Dialog({
            title: resourceBundle.getText("cancelLeave"),
            type: "Message",
            content: new Text({ text: resourceBundle.getText("cancelLeaveConfirmation") }),
            beginButton: new Button({
                text: resourceBundle.getText("yes"),
                press: async () => {
                    try {
                        dialog.close();
                        await DataService.cancelLeave(leaveData);
                    } catch (error) {
                        console.error(error);
                    } finally {
                        DataService.getUserData();

                    }
                }
            }),
            endButton: new Button({
                text: resourceBundle.getText("no"),
                press: () => {
                    dialog.close();
                }
            }),
            afterClose: () => {
                dialog.destroy();
            }
        });

        dialog.open();
    }

    public onCloseDialog(): void {
        this.destroyDialog(this.DIALOG_ID);
    }

    onNoStandInChange(): void {
        const viewModel = this.getView().getModel("viewModel") as JSONModel;
        if (viewModel.getProperty("/noStandIn")) {
            const leave = this.getView().getModel("leave") as JSONModel;
            leave.setProperty("/substituteId", undefined);
        }
    }

    onFilter(): void {
        const viewModel = this.getView().getModel("viewModel") as JSONModel;
        const aSelectedKeys = viewModel.getProperty("/selectedStatuses");
        const year = viewModel.getProperty("/year");
        const oTable = this.byId("idItemsHistoryTable") as Table;
        const oBinding = oTable.getBinding("items");
        let aFilters: Filter[] = [];

        // Add status filters
        if (aSelectedKeys && aSelectedKeys.length > 0) {
            const statusFilters = aSelectedKeys.map((sKey: string) => new Filter("status", FilterOperator.EQ, sKey));
            aFilters.push(new Filter({ filters: statusFilters, and: false }));
        }

        // Add year filters
        const startDateFilter = new Filter({
            path: "startDate",
            operator: FilterOperator.BT,
            value1: `${year.getFullYear()}-01-01`,
            value2: `${year.getFullYear()}-12-31`
        });

        const endDateFilter = new Filter({
            path: "endDate",
            operator: FilterOperator.BT,
            value1: `${year.getFullYear()}-01-01`,
            value2: `${year.getFullYear()}-12-31`
        });

        const combinedYearFilter = new Filter({
            filters: [startDateFilter, endDateFilter],
            and: false
        });

        aFilters.push(combinedYearFilter);

        // Apply combined filters
        oBinding.filter(aFilters.length > 0 ? new Filter({ filters: aFilters, and: true }) : []);
    }
}